<template>
  <div>
    <c-button
      data-cy="notifications-button"
      class="button"
      size="lg"
      icon="bell2"
      ref="menu"
      @click="showPopover = !showPopover, handleAnalytics()"
    />
    <c-popover
      v-if="showPopover"
      :position="notificationsPosition"
      :target="$refs['menu']"
      @blur="showPopover = false"
    >
      <NotificationsList @close="showPopover = false" />
    </c-popover>
  </div>
</template>

<script>
import NotificationsList from '@/components/Notifications/NotificationsList'
import { CONFIG_MAIN } from '@store/types'
import { mapGetters } from 'vuex'
export default {
  components: {
    NotificationsList
  },
  data () {
    return {
      showPopover: false
    }
  },
  computed: {
    ...mapGetters({
      config: CONFIG_MAIN
    }),
    notificationsPosition () {
      if (this.isLgScreen) return ['top', 'right']
      return ['top', 'center']
    }
  },

  methods: {
    handleAnalytics () {
      window.dataLayer.push({
        event: 'area-de-notificacoes',
        company_name: this.config.title
      })
    }
  }

}
</script>

<style lang="scss" scoped>
@import '~@style/reference.scss';
.container {
  height: 17.8rem;
  width: 26.3rem;
  box-shadow: $shadow-color 0px 0px 5px;
  display: inherit;

  .content {
    background-color: $background-color;
    height: 86%;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/Notifications/NotificationsContainer.vue